import axios from "axios";
import Cookies from "js-cookie";
import { EnvironmentVariables } from "@/modules/common/types";

export function journeyTopic(orgUid: string, journeyUid: string): string {
  return `sse:org:${orgUid}:journey:${journeyUid}`;
}

// Topics are sent in the (authenticated) ticket POST body, not the subscribe query string, so the
// EventSource URL stays short — ~100 channel strings in the URL exceed the gateway limit (414).
export async function fetchSseTicket(topics: string[]): Promise<string> {
  const usernameString = `CognitoIdentityServiceProvider.${EnvironmentVariables.AWS_CLIENT_ID}.LastAuthUser`;
  const username = localStorage.getItem(usernameString);
  const idTokenKey = `CognitoIdentityServiceProvider.${EnvironmentVariables.AWS_CLIENT_ID}.${username}.idToken`;
  const token = localStorage.getItem(idTokenKey) ?? Cookies.get("accessToken");

  const response = await axios.post<{ ticket: string; expiresInSeconds: number }>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/sse/ticket`,
    { topics },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return response.data.ticket;
}

export function buildSubscribeUrl(ticket: string): string {
  const params = new URLSearchParams({ ticket });
  return `${EnvironmentVariables.SSE_GATEWAY_URL}?${params.toString()}`;
}
